<div class="recortador-archivos">
  <div class="subir" *ngIf="!cropService.imagen" [ngClass]="{ 'subir-invalid': hasError }"
    (dragover)="onDragOver($event)" (drop)="onDrop($event)">
    <i class="ri-image-2-line"></i>
    <div class="body-small">
      Arrastra y suelta aquí el comprobante de pago
      o <label for="upload" class="bodylink-small">súbelo</label> desde tu dispositivo
    </div>

    <input id="upload" type="file" (change)="cargarImagen($event)" accept="image/png, image/jpeg" />
  </div>
  <div class="invalid-image body-x-small" *ngIf="hasError">
    La imagen cargada no es válida
  </div>

  <div class="recortar" *ngIf="cropService.imagen">
    <image-cropper [imageChangedEvent]="cropService.imagen" [imageURL]="cropService.imagen" [aspectRatio]="aspect"
      format="png" (imageCropped)="cortarImagen($event)" [maintainAspectRatio]="false" [transform]="options"
      [canvasRotation]="rotation"></image-cropper>

    <div class="crop-footer">
      <div class="zoom">
        <input (input)="zoom($event)" type="range" min="1" max="5" step="1" [value]="options.scale" />

        <div>
          <p class="body-x-small">Zoom</p>
          <p class="body-x-small">{{ options.scale }}</p>
        </div>
      </div>
      <div class="opciones">
        <div class="cursor" (click)="expandir()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.57422 8.99413L2.28419 12.2842L1 11C0.44725 11 0 11.4473 0 12V15C0 15.5527 0.44725 16 1 16H4C4.55275 16 5 15.5527 5 15L3.71578 13.7168L7.00581 10.4258L5.57422 8.99413ZM15 0H12C11.4473 0 11 0.44775 11 1L12.2842 2.28419L8.99413 5.57422L10.4257 7.00584L13.7158 3.71628L15 5C15.5527 5 16 4.55275 16 4V1C16 0.44775 15.5527 0 15 0ZM15 11L13.7158 12.2842L10.4258 8.99416L8.99416 10.4258L12.2842 13.7168L11 15C11 15.5527 11.4473 16 12 16H15C15.5527 16 16 15.5527 16 15V12C16 11.4473 15.5527 11 15 11ZM5 1C5 0.44775 4.55275 0 4 0H1C0.44725 0 0 0.44775 0 1V4C0 4.55275 0.44725 5 1 5L2.28419 3.71631L5.57422 7.00588L7.00584 5.57425L3.71581 2.28419L5 1Z"
              fill="#E2E2E2" />
          </svg>
          <p class="body-x-small">Expandir</p>
        </div>

        <div class="cursor" (click)="rotar()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 1.5V6C15 6.55281 14.5528 7 14 7H9.5C8.94719 7 8.5 6.55281 8.5 6C8.5 5.44719 8.94719 5 9.5 5H11.4809C10.5444 3.75938 9.06687 3.00688 7.49344 3.00688C4.74062 3.00688 2.5 5.24687 2.5 8C2.5 10.7531 4.74031 12.9937 7.49375 12.9937C8.58375 12.9937 9.61969 12.6491 10.49 11.9956C10.9344 11.6666 11.5594 11.7534 11.8903 12.1948C12.2212 12.6373 12.1325 13.2642 11.6911 13.5952C10.4714 14.5102 9.02359 14.997 7.49734 14.997C3.64062 14.9969 0.5 11.8562 0.5 8C0.5 4.14375 3.64062 1.00312 7.49687 1.00312C9.65781 1.00312 11.6844 2.01781 13 3.69438V1.5C13 0.947187 13.4472 0.5 14 0.5C14.5528 0.5 15 0.947187 15 1.5Z"
              fill="#E2E2E2" />
          </svg>

          <p class="body-x-small">Rotar</p>
        </div>

        <div class="cursor" (click)="borrar()">
          <i class="ri-delete-bin-line"></i>
          <p class="body-x-small">Borrar</p>
        </div>
      </div>
    </div>
  </div>
</div>